import { Block } from 'components/Shared/Layout';
import { rm } from 'utils';
import styles from './styles.scss';
import Button from 'components/Shared/Button';
import { IconArrow } from 'components/Shared/Icon';
import { Times, useCountdown, pad } from 'components/CountdownAd/useCountdown';
import { CountdownAdProps } from 'components/CountdownAd/props';

const formatTime = ({ days, hours, minutes, seconds }: Times) =>
  `${pad(days)}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

export const CountdownAd = ({ url, title, endTime }: CountdownAdProps) => {
  const time = useCountdown(endTime);
  return (
    <Block className={styles.base} shadow>
      <div className={styles.salesLine}>{rm('countdown_salesline')}</div>
      <div className={styles.angle} />
      <div className={styles.message}>{title}</div>
      <div className={styles.time}>
        <span className={styles.timeLeft}>{rm('countdown_timeto')}:</span>
        <span className={styles.timer}>{formatTime(time)}</span>
      </div>
      {url && (
        <div className={styles.offer}>
          <Button className={styles.button} href={url}>
            {rm('countdown_offer_button')}
            <IconArrow size="tiny" />
          </Button>
        </div>
      )}
    </Block>
  );
};
